import React, { Component } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import MultiLineText from './MultiLineText';

import Checkmark from '../../../assets/svg/Checkmark';

import { paragraph } from '../../../styling/mixins/typography';
import {
  MOBILE_END_QUERY,
  DESKTOP_START_QUERY,
  DESKTOP_MEDIUM_START_QUERY,
} from '../../../styling/mixins/responsive';
import colors from '../../../styling/colors';

const List = styled.div`
  ${paragraph};
  display: block;
  text-align: left;

  @media (${DESKTOP_START_QUERY}) {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
  }
`;

const StyledCheckmark = styled(Checkmark)`
  flex: none;
  align-self: flex-start;
  margin-right: 0.5rem;
`;

const Text = styled.div`
  align-items: center;
  display: flex;
  font-weight: 400;
  letter-spacing: -0.1px;
  line-height: 1.25em;
  margin-bottom: 0.75rem;
  text-align: left;

  @media (${DESKTOP_MEDIUM_START_QUERY}) {
    font-size: 1rem;
  }
`;

const Description = styled.div`
  color: ${colors('boulder')};
  margin-bottom: 2rem;

  @media (${MOBILE_END_QUERY}) {
    font-size: 0.75rem;
    line-height: 20px;
  }

  p {
    margin: 0;
  }
`;

export class CheckList extends Component {
  static propTypes = {
    list: PropTypes.arrayOf(
      PropTypes.shape({
        checkItem: PropTypes.string.isRequired,
        itemDescription: PropTypes.arrayOf(PropTypes.string),
      }),
    ).isRequired,
    isMobile: PropTypes.bool,
  };

  render() {
    const { className, list, isMobile } = this.props;

    return (
      <List className={className}>
        {list.map((item, key) => {
          return (
            <div key={key}>
              <Text>
                <StyledCheckmark />
                {item.checkItem}
              </Text>
              {!isMobile && item.itemDescription && (
                <Description>
                  <MultiLineText lines={item.itemDescription} />
                </Description>
              )}
            </div>
          );
        })}
      </List>
    );
  }
}

export const PaddedCheckList = styled(CheckList)`
  width: 95%;

  @media (${DESKTOP_START_QUERY}) {
    width: 64%;
  }
`;

export default CheckList;
